<template>
  <emd-card v-if="isItems">
    <emd-card-header>
      <emd-text size="section"> {{ $t('header') }}</emd-text>
    </emd-card-header>
    <emd-card-content>
      <emd-text-section
        v-for="(item, idx) in data"
        :title="`Item ${item.number}`"
        :key="idx"
      >
        <emd-text-content
          :title="$t('name')"
          :content="item.name"
        />
        <emd-text-content
          :title="$t('description')"
          :content="item.description"
        />
        <emd-text-content
          :title="$t('quantity')"
          :content="item.quantity"
        />
        <emd-text-content
          :title="$t('amount')"
          :content="item.amount"
        />
        <emd-text-content
          :title="$t('totalAmount')"
          :content="item.totalAmount"
        />
      </emd-text-section>
    </emd-card-content>
  </emd-card>
</template>

<script>
import {
  EmdText,
  EmdCard,
  EmdCardHeader,
  EmdCardContent,
  EmdTextSection,
  EmdTextContent
} from 'emerald-vue/src/components'

export default {
  name: 'ItemsLink',

  components: {
    EmdText,
    EmdCard,
    EmdCardHeader,
    EmdCardContent,
    EmdTextSection,
    EmdTextContent
  },

  props: {
    data: Array,
    default: () => []
  },

  computed: {
    isItems () {
      return this.data?.length > 0
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "header": "Itens",
      "name": "Nome",
      "description": "Descrição",
      "quantity": "Quantidade",
      "amount": "Valor unitário",
      "totalAmount": "Valor total"
    },
    "en-US": {
      "header": "Items",
      "name": "Name",
      "description": "Description",
      "quantity": "Quantity",
      "amount": "Amount",
      "totalAmount": "Total amount"
    }
  }
</i18n>
